export enum PointType {
  CORNER = 'corner', // figure's corner
  ARC = 'arc', // imaginary point of wall-arc
  CENTER = 'center', // imaginary point of the middle of a circle
  LABEL = 'label', // point is label-based
  BLUE_PRINT_IMAGE = 'image', // point is label-based
}
